export const moduleConfig = {
    entityKey: 'billable-events',
    // Every navigate/link in the module builds on this, never a literal path.
    basePath: '/billable-events',
    titles: {
        singular: 'Billable Event',
        plural: 'Billable Events'
    }
}
